<template>
    <div class="customize-profile">
        <Header @cart-ref="setCartRef" />
        <div class="main-content">
            <div class="customize-container">
                <!-- <div class="header-search">
                    <Search />
                </div> -->

                <h2 class="customize-title"><i class="fa-solid fa-paintbrush"></i> Personalizar Perfil</h2>

                <div class="customize-content">
                    <!-- Seção de Logo -->
                    <div class="section-card">
                        <h3 class="section-title"><i class="fa-solid fa-image"></i> Logo da Instituição</h3>
                        <div class="logo-preview">
                            <img :src="customization.logo || require('@/assets/logos/logo.png')" 
                                 alt="Logo" 
                                 class="preview-logo" />
                            <label class="camera-icon" for="logo-upload">
                                <img src="@/assets/icons/camera.png" alt="Alterar Logo" />
                                <input 
                                    type="file" 
                                    id="logo-upload" 
                                    accept="image/*" 
                                    @change="handleLogoUpload"
                                    style="display: none;"
                                />
                            </label>
                        </div>
                        <p class="section-description">Clique no ícone da câmera para alterar a logo</p>
                    </div>

                    <!-- Seção de Cores do Header -->
                    <div class="section-card">
                        <h3 class="section-title"><i class="fa-solid fa-palette"></i> Cor do Header</h3>
                        <div class="color-palette">
                            <div 
                                v-for="color in headerColors" 
                                :key="color.name"
                                class="color-option"
                                :class="{ active: customization.headerColor === color.value }"
                                :style="{ backgroundColor: color.value }"
                                @click="selectHeaderColor(color.value)"
                                :title="color.name"
                            >
                                <i v-if="customization.headerColor === color.value" class="fas fa-check"></i>
                            </div>
                            
                            <div class="color-option custom-picker-circle" title="Cor Personalizada">
                                <input 
                                    type="color" 
                                    v-model="customization.headerColor"
                                    @input="updateHeaderColor"
                                    class="color-input-circle"
                                />
                                <i class="fas fa-plus"></i>
                            </div>
                        </div>
                        <div class="custom-color-picker">
                            <label>Cor HEX:</label>
                            <div class="color-input-wrapper">
                                <input 
                                    type="text" 
                                    v-model="customization.headerColor"
                                    @input="updateHeaderColor"
                                    class="hex-input"
                                    placeholder="#000000"
                                    maxlength="7"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Seção de Background -->
                    <div class="section-card">
                        <h3 class="section-title"><i class="fa-solid fa-fill-drip"></i> Background do Site</h3>
                        <div class="color-palette">
                            <div 
                                v-for="color in backgroundColors" 
                                :key="color.name"
                                class="color-option"
                                :class="{ active: customization.backgroundColor === color.value }"
                                :style="{ backgroundColor: color.value }"
                                @click="selectBackgroundColor(color.value)"
                                :title="color.name"
                            >
                                <i v-if="customization.backgroundColor === color.value" class="fas fa-check"></i>
                            </div>
                            
                            <div class="color-option custom-picker-circle" title="Cor Personalizada">
                                <input 
                                    type="color" 
                                    v-model="customization.backgroundColor"
                                    @input="updateBackgroundColor"
                                    class="color-input-circle"
                                />
                                <i class="fas fa-plus"></i>
                            </div>
                        </div>
                        <div class="custom-color-picker">
                            <label>Cor HEX:</label>
                            <div class="color-input-wrapper">
                                <input 
                                    type="text" 
                                    v-model="customization.backgroundColor"
                                    @input="updateBackgroundColor"
                                    class="hex-input"
                                    placeholder="#000000"
                                    maxlength="7"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Preview -->
                    <div class="section-card preview-section">
                        <h3 class="section-title"><i class="fa-solid fa-eye"></i> Pré-visualização</h3>
                        <div class="preview-box">
                            <div class="preview-header" :style="{ backgroundColor: customization.headerColor }">
                                <img :src="customization.logo || require('@/assets/logos/logo.png')" 
                                     alt="Logo Preview" 
                                     class="preview-header-logo" />
                            </div>
                            <div class="preview-content" :style="{ background: customization.backgroundColor }">
                                <p>Exemplo de conteúdo da página</p>
                            </div>
                        </div>
                    </div>

                    <!-- Botões de Ação -->
                    <div class="action-buttons">
                        <button class="btn-save" @click="saveCustomization">
                            <i class="fas fa-save"></i> Salvar Personalização
                        </button>
                        <button class="btn-reset" @click="resetCustomization">
                            <i class="fas fa-undo"></i> Restaurar Padrão
                        </button>
                        <button class="btn-cancel" @click="$router.back()">
                            <i class="fas fa-times"></i> Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Toast de notificação -->
        <div v-if="showToast" class="toast-notification" :class="toastType">
            <i :class="toastIcon"></i>
            <span>{{ toastMessage }}</span>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import requestV2 from '@/router/requestV2.js';

export default {
    name: 'CustomizeProfile',
    components: {
        Header,
        // Search
    },
    data() {
        return {
            cartComponent: null,
            customization: {
                logo: null,
                headerColor: '#09105D',
                backgroundColor: '#09105D'
            },
            defaultCustomization: {
                logo: null,
                headerColor: '#09105D',
                backgroundColor: '#09105D'
            },
            headerColors: [
                { name: 'Azul Escuro', value: '#09105D' },
                { name: 'Azul Médio', value: '#1322C1' },
                { name: 'Azul Claro', value: '#5DADE2' },
                { name: 'Verde', value: '#27AE60' },
                { name: 'Roxo', value: '#8E44AD' },
                { name: 'Vermelho', value: '#C0392B' },
                { name: 'Laranja', value: '#E67E22' },
                { name: 'Cinza Escuro', value: '#2C3E50' },
                { name: 'Branco', value: '#FFFFFF' }
            ],
            backgroundColors: [
                { name: 'Azul Escuro', value: '#09105D' },
                { name: 'Azul Médio', value: '#1322C1' },
                { name: 'Azul Claro', value: '#5DADE2' },
                { name: 'Verde', value: '#27AE60' },
                { name: 'Roxo', value: '#8E44AD' },
                { name: 'Vermelho', value: '#C0392B' },
                { name: 'Laranja', value: '#E67E22' },
                { name: 'Cinza Escuro', value: '#2C3E50' },
                { name: 'Branco', value: '#FFFFFF' }
            ],
            showToast: false,
            toastMessage: '',
            toastType: 'success'
        };
    },
    computed: {
        toastIcon() {
            return this.toastType === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle';
        }
    },
    methods: {
        handleLogoUpload(event) {
            const file = event.target.files[0];
            if (file) {
                if (file.size > 2 * 1024 * 1024) { // 2MB
                    this.showNotification('A imagem deve ter no máximo 2MB', 'warning');
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.customization.logo = e.target.result;
                    this.applyCustomization();
                };
                reader.readAsDataURL(file);
            }
        },
        selectHeaderColor(color) {
            this.customization.headerColor = color;
            this.updateHeaderColor();
        },
        selectBackgroundColor(color) {
            this.customization.backgroundColor = color;
            this.updateBackgroundColor();
        },
        updateHeaderColor() {
            this.applyCustomization();
        },
        updateBackgroundColor() {
            this.applyCustomization();
        },
        getContrastColor(hexColor) {
            // Remove # se existir
            const hex = hexColor.replace('#', '');
            
            // Converte para RGB
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);
            
            // Calcula luminância
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            
            // Retorna branco para cores escuras e azul escuro (#09105D) para cores claras
            return luminance > 0.5 ? '#09105D' : '#FFFFFF';
        },
        applyCustomization() {
            // Calcula cor de fonte baseada no contraste
            const fontColor = this.getContrastColor(this.customization.backgroundColor);
            
            // Aplica as cores ao documento
            document.documentElement.style.setProperty('--header-color', this.customization.headerColor);
            document.documentElement.style.setProperty('--background-color', this.customization.backgroundColor);
            document.documentElement.style.setProperty('--font-color', fontColor);
            
            // Salva no localStorage para aplicar imediatamente
            localStorage.setItem('customization', JSON.stringify(this.customization));
        },
        async saveCustomization() {
            try {
                const partnerId = localStorage.getItem('codigo_parceiro') || 1; // Fallback para dev local
                await requestV2.put(`/customization/${partnerId}`, {
                    logo: this.customization.logo,
                    header_color: this.customization.headerColor,
                    background_color: this.customization.backgroundColor
                });

                this.applyCustomization();
                this.showNotification('Personalização salva com sucesso! Todos os usuários do seu parceiro verão essas alterações.', 'success');
            } catch (error) {
                console.error('Erro ao salvar personalização:', error);
                this.showNotification('Erro ao salvar personalização. Tente novamente.', 'warning');
            }
        },
        resetCustomization() {
            if (confirm('Deseja realmente restaurar as configurações padrão?')) {
                this.customization = { ...this.defaultCustomization };
                this.applyCustomization();
                this.saveCustomization();
                this.showNotification('Personalização restaurada para o padrão', 'success');
            }
        },
        async loadCustomization() {
            try {
                const partnerId = localStorage.getItem('codigo_parceiro') || 1;
                const response = await requestV2.get(`/customization/${partnerId}`);
                
                if (response.data) {
                    const data = response.data;
                    this.customization = {
                        logo: data.logo || this.defaultCustomization.logo,
                        headerColor: data.header_color || this.defaultCustomization.headerColor,
                        backgroundColor: data.background_color || this.defaultCustomization.backgroundColor
                    };
                    this.applyCustomization();
                }
            } catch (error) {
                console.error('Erro ao carregar personalização da API:', error);
                // Tenta carregar do localStorage como fallback
                const savedCustomization = localStorage.getItem('customization');
                if (savedCustomization) {
                    this.customization = JSON.parse(savedCustomization);
                    this.applyCustomization();
                }
            }
        },
        showNotification(message, type = 'success') {
            this.toastMessage = message;
            this.toastType = type;
            this.showToast = true;
            
            setTimeout(() => {
                this.showToast = false;
            }, 3000);
        },
        setCartRef(cartRef) {
            this.cartComponent = cartRef;
        }
    },
    mounted() {
        this.loadCustomization();
    }
};
</script>

<style scoped src="../styles/CustomizeProfile.css" />